'use strict';

module.exports = {
  cdt: 'cdt',
  displayGroup: 'displayGroup',
  chain: 'chain',
  role: 'role',
  series: 'series'
};
